import { BrowserRouter, Route, Routes } from 'react-router-dom';

import AppRoutes from "./Routes/appRoutes"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { configureReduxStore } from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
function App() {
  const { store, persistor } = configureReduxStore();
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          <ToastContainer
            position="top-right" // Adjust the position as needed
            autoClose={5000} // Adjust the autoClose time as needed
          />
        </PersistGate>
      </Provider>
    </>
  );
}


export default App;
